// extracted by mini-css-extract-plugin
export default {"buttonContainer":"fTqLQ","alignToEdge":"g1LNw","buttonIcon":"kvPRw","buttonCaption":"CI5U5","buttonSpacer":"NQcHQ"};